var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('h1',{attrs:{"id":"about"}},[_vm._v("Interests")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.about),function(item){return _c('v-flex',[_c('list-card',{attrs:{"value":item,"img-width":'60px',"gallery-width":'100px',"width":'250px'}})],1)}))],1),_vm._v(" "),_c('br'),_c('v-divider')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b414198","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/about.vue
// module id = 67
// module chunks = 0